import React, { useState, useEffect, useRef } from "react";
import { useTheme } from "@mui/material";
import { useRouter } from "next/router";
import { useStore } from "outstated";
import { AppStore } from "pages/_app.js";
import dayjs from "dayjs";

// mui
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Collapse from "@mui/material/Collapse";
import Skeleton from "@mui/material/Skeleton";
import Alert from "@mui/material/Alert";

import InputAdornment from "@mui/material/InputAdornment";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ButtonBase from "@mui/material/ButtonBase";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

// lib
import formatMoney from "lib/formatMoney";
import scroller from "lib/scroller";
import sleep from "lib/sleep";
// components

import loadCalculation from "components/Calculators/components/utils/loadCalculation";
import createCalc from "components/Calculators/DSCRCalculator/utils/createCalc";
import updateCalc from "components/Calculators/DSCRCalculator/utils/updateCalc";
import * as gtag from "components/GTagManager";
import dynamic from "next/dynamic";
const AddressAutocomplete = dynamic(() =>
  import("components/AddressAutocomplete")
);
import SaveSharePDF from "components/Calculators/components/SaveSharePDF";
// import QuestionRenderer from "components/Calculators/CashOnCashReturnCalculator/components/QuestionRenderer";
import Authenticator from "components/Authenticator";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";

const calcType = "Cash out refinance";

export default function CashOutRefinanceCalculator({
  externalCalc,
  loadCalcs,
  refCalcs,
  externalExampleCalc,
}) {
  return <Box>{calcType}</Box>;
}
